/* גלילה לעוגן אחרי מעבר בין עמודים.
   נדרש כי React Router אינו מטפל בעוגנים (#hash) מעצמו. */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToAnchor(): void {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });

      return;
    }

    /* ההשהיה מאפשרת לתוכן העמוד להתרנדר לפני חיפוש היעד */
    const timeoutId = window.setTimeout(() => {
      /* getElementById ולא querySelector — האחרון זורק על מזהה שאינו
         סלקטור תקין, למשל עוגן מספרי כמו #2024 */
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));

      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);

    return () => window.clearTimeout(timeoutId);
  }, [hash, pathname]);
}
